import axios from "axios";
import MainService from "./MainService";
export default class DestinationService extends MainService {

	constructor() {
		super();
		this.url = `${this.apiUrl}`;
	}

    listCitiesByName(name) {
        const data = new FormData();
        data.append('name', name);
        return axios.post(`${this.url}/cities/filter`, data);
    }

}



// WEBPACK FOOTER //
// ./src/service/DestinationService.js